export function escapeHtml(value) {
  return String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

export function formatDocumentType(type) {
  if (!type) return 'ID Document';
  return String(type)
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}

export function getDocumentSideTitle(documentType, side) {
  return `${formatDocumentType(documentType)} ${side}`;
}

export function getSelectedHotelFromContext() {
  if (typeof window === 'undefined') return {};
  return window.DJANGO_CONTEXT?.selectedHotel || {};
}

export function formatPolicyTime(raw, fallback) {
  const value = String(raw || '').trim();
  if (!value) return fallback;
  const match = value.match(/^(\d{1,2}):(\d{2})(?::\d{2})?/);
  if (!match) return value;
  const hours = Number(match[1]);
  const minutes = match[2];
  if (!Number.isFinite(hours)) return value;
  const suffix = hours >= 12 ? 'PM' : 'AM';
  const hour12 = hours % 12 || 12;
  return `${String(hour12).padStart(2, '0')}:${minutes} ${suffix}`;
}

export function joinNonEmpty(parts, separator = ', ') {
  return (parts || []).map((part) => String(part || '').trim()).filter(Boolean).join(separator);
}
